<template>
  <div :class="$style.wrap">
    <div :class="$style.title">
      <p>手机注册</p>
      <p>欢迎注册极致手机账号</p>
    </div>
    <base-form
      ref="form"
      has-captcha="send"
      :items="data"
      label-width="2em"
      submit-text="注册"
      @submit="onSubmit"
    />
    <Agreement ref="agreement" />
  </div>
</template>
<script>
import { mixinRegistered } from "@/mixins/mixinRegistered";
import fallback from "@/utils/fallback";
import { mixinForward } from "@/mixins/mixinForward";

export default {
  name: "mobilePhone",
  mixins: [mixinRegistered, mixinForward],
  data() {
    return {
      data: [
        { name: "iconPhone" },
        { name: "password" },
        {
          name: "iconPhoneCode",
          type: 0,
          moduleType: false
        }
      ]
    };
  },
  mounted() {
    // 初使化 md5
    if (!window.hex_md5) fallback("md5");
    this.data[0].value = this.$route.query.phone ? this.$route.query.phone : "";
  },
  methods: {
    /**
     * @description 步骤提交
     * @param {object} formdata  - 表单对象值
     * @param {object} validate  - 极致验证
     */
    onSubmit(formdata, validate) {
      let { iconPhone, password, iconPhoneCode } = formdata;

      // 验证密码是否与输入的手机号码相同
      if (iconPhone == password) {
        this.showToast();
        return false;
      }

      // 验证协议是否勾选
      if (!this.$refs.agreement || !this.$refs.agreement.checked) {
        this.showToast("请先勾选用户协议及隐私政策");
        return false;
      }

      let parmas = Object.assign(
        {},
        {
          phone: iconPhone,
          password: window.hex_md5(password),
          code: iconPhoneCode,
          type: 1 //手机正常注册
        },
        validate || {}
      );
      this.doPhone(parmas);
    }
  }
};
</script>

<style lang="less" module>
.wrap {
  :global {
    .van-field__control {
      padding: 0.16rem 0 0.16rem 0.7rem;
    }
  }
  .title {
    margin: 0.6rem 0 0.86rem 0;
    padding-left: 0.45rem;

    p {
      color: #222222;
    }
    p:first-child {
      font-size: 0.36rem;
      margin-bottom: 0.28rem;
      font-weight: bold;
    }
    p:last-child {
      font-size: 0.25rem;
    }
  }
}
</style>
